<template>
  <section class="recent-map mt-5">
    <div class="recent-map-left">
      <h4>Your recent ancestry results</h4>
      <div v-for="(region, index) in regions" :key="index">
        <p class="d-flex align-items-center recent-map-list-main">
          <span>{{ region.title }}</span>
          <span v-if="region.percentage" class="ms-auto">{{ region.percentage }}%</span>
        </p>
        <ul class="list-unstyled">
          <li class="recent-map-list-secondary recent-map-list-first-li" v-for="(item, itemIndex) in region.children"
            :key="itemIndex">
            <div class="d-flex align-items-center recent-map-list-first">
              <span class="badge-small me-3" :style="{ background: item.colour || item.children[0].colour }"></span>
              <span>{{ item.title || "Unlock to discover this region" }}</span>
              <span v-if="item.percentage" class="px-2 ms-auto">{{ item.percentage }}%</span>
              <i class="fa-solid fa-angle-right"></i>
            </div>
            <ul class="list-unstyled">
              <li class="d-flex align-items-center recent-map-list-secondary"
                v-for="(subregion, subregionIndex) in item.children" :key="subregionIndex">
                <span class="badge-small me-3" :style="{ background: subregion.colour }"></span>
                <span>{{ subregion.title || "Unlock to discover this region" }}</span>
                <span v-if="subregion.percentage" class="px-2 ms-auto">{{ subregion.percentage }}%</span>
                <i class="fa-solid fa-angle-right"></i>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="recent-map-right">
      <RecentAncestryMap :autosomal-result="regions" :key="profileBarcode" />
    </div>
  </section>
</template>
<script setup>
import { defineProps } from 'vue';
import RecentAncestryMap from "@/view/sharing/SharingRecentAncestryMap.vue";
//import Recentmap from '@/assets/images/share/recentmap.jpg';
defineProps({
  regions: Array,
});
/* const continents = [
        {
          name: "Europe",
          percentage: 79.9,
          regions: [
            { name: "Great Britain and Ireland", percentage: 79.9, bg: 'rgb(51, 119, 255)' },
            { name: "Central England", percentage: 15.2, bg: 'rgb(51, 119, 255)' },
            { name: "Northwest England", percentage: 13.3, bg: 'rgb(172, 219, 72)' },
            { name: "Ireland", percentage: 11.6, bg: 'rgb(51, 119, 255)' },
            { name: "Southeast England", percentage: 8, bg: 'rgb(51, 119, 255)' },
            { name: "South England", percentage: 7.9, bg: 'rgb(51, 119, 255)' },
            { name: "North Yorkshire", percentage: 6.2, bg: 'rgb(51, 119, 255)' },
            { name: "East Anglia", percentage: 4.2, bg: 'rgb(51, 119, 255)' },
            { name: "Aberdeenshire", percentage: 3.3, bg: 'rgb(51, 119, 255)' },
            { name: "Cornwall", percentage: 2.7, bg: 'rgb(51, 119, 255)' },
            { name: "Northumbria", percentage: 2.3, bg: 'rgb(51, 119, 255)' },
            { name: "South Wales", percentage: 2.1, bg: 'rgb(51, 119, 255)' },
            { name: "South Yorkshire", percentage: 1.6, bg: 'rgb(51, 119, 255)' },
            { name: "Devon", percentage: 1.5, bg: 'rgb(51, 119, 255)' },
          ]
        },
        {
          name: "Near East",
          percentage: 14.9,
          regions: [
            { name: "South Caucasus", percentage: 14.9, bg: 'rgb(34, 124, 114)' }
          ]
        },
        {
          name: "Asia (Central)",
          percentage: 5.2,
          regions: [
            { name: "Northwestern Caucasus", percentage: 5.2, bg: 'rgb(133, 181, 28)' }
          ]
        }
      ]; */
</script>
<style lang="scss">
.recent-map {
  display: grid;
  grid-template-columns: 1fr;

  @media(min-width:768px) {
    grid-template-columns: 360px 1fr;

    &.single-column {
      grid-template-columns: 1fr;
    }
  }

  h4 {
    margin-bottom: 20px;
    color: #6d6e71;
  }

  i {
    color: #6d6e71;
  }

  .badge-small {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .recent-map-list-first {
    .badge-small {
      width: 12px;
      height: 12px;
    }
  }

  &-left {
    background: #f9fafb;
    padding: 24px;
    border-radius: 4px;
    max-height: 527px;
    overflow: auto;
  }

  &-right {
    order: -1;

    @media(min-width:768px) {
      order: 1;
    }

    .mapboxgl-map {
      height: 450px;


      @media(min-width:768px) {
        height: 527px;
      }
    }


  }

  &-list-main {
    margin-block: 16px 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e6ee;
  }

  &-list-secondary {
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 300;

    &:hover {
      background: rgba(51, 119, 255, .08)
    }
  }

  .recent-map-list-first-li {
    padding: 0;

    .recent-map-list-first {
      padding: 8px;

      &:hover {
        background: rgba(51, 119, 255, .08)
      }
    }

    &:hover {
      background: transparent;
    }
  }
}
</style>